<ngx-dialog-wizard-base [data]="data">

  <ng-template wizardStep let-data="data">
    <h4>You are about to complete the project</h4>
    click next to continue
    cancel to abort
  </ng-template>

  <ng-template wizardStep let-data="data">
    <h4>Print Overview</h4>
    <button class="btn btn-default" (click)="pm.downloadProfitCalcPdf(true)"><i class="fa fa-print"></i> Print</button>
    <ngx-profit-margin #pm [compilation]="data.compilation" [type]="profitMarginType.ocSpo" [withChecklist]="true"></ngx-profit-margin>
  </ng-template>

  <ng-template wizardStep let-data="data">
    <h4>Prepare Project closure email</h4>
  </ng-template>

  <ng-template wizardStep let-data="data">
    <h4>Move Project Soft copy foder to MBU and corresponding FY</h4>
  </ng-template>

  <ng-template wizardStep let-data="data">
    <h4>Finalize Project Now</h4>
  </ng-template>

</ngx-dialog-wizard-base>
